var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"items":_vm.items,"loading":_vm.loading,"headers":_vm.headers},scopedSlots:_vm._u([(_vm.isDetailed)?{key:"item.action",fn:function(ref){
var item = ref.item;
return [_c('ShippingMiscForm',{attrs:{"instance":item,"is-edit":true,"ticketid":_vm.id}}),_c('ShippingLineItemDelete',{attrs:{"instance":item}})]}}:null],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }